import React, { useMemo } from "react";
import { Link, useLocation, NavLink } from "react-router-dom";
import Unauthorized from "@components/layout/Header/components/Unauthorized";
import useMediaQuery from "@mui/material/useMediaQuery";
import Authorized from "@components/layout/Header/components/Authorized";
import { MAIN_PAGE, NAV_ITEMS_HEADER } from "@constants";
import { useSelector } from "react-redux";
import { useTranslation } from "@helpers/translate";
import { LogoIcon } from "@components/library";
import BlockIcon from "@assets/icons/BlockIcon";

import "./header.sass";

export const Header = ({ sidebarToggle }) => {
  const isDesktop = useMediaQuery("(min-width:1124px)");
  // const isTablet = useMediaQuery(theme.breakpoints.up("lg"));
  const location = useLocation();
  const { isAuth, isDemoUser } = useSelector((state) => state.auth);
  const { __ } = useTranslation();

  const currentPath = location.pathname;

  const isAuthRoute = useMemo(
    () => currentPath.startsWith("/auth/"),
    [currentPath],
  );
  const isMainPage = useMemo(() => currentPath === MAIN_PAGE, [currentPath]);
  // const isTradingPage = useMemo(() => TRADING_PAGES.includes(currentPath), [currentPath]);

  const isLandingView = (!isAuth || isDemoUser) && (isMainPage || isAuthRoute);

  return (
    <header className={`header${isLandingView ? " header--fixed" : ""}`}>
      <div className="header__wrapper">
        {isDesktop ? (
          <div className="header__left">
            <>
              <Link className="header__logo" to="/">
                <LogoIcon isLanding={isLandingView} />
              </Link>

              {/* Головне меню */}
              <ul className="header__main-nav">
                {NAV_ITEMS_HEADER.map((item) => (
                  <li
                    key={item.key}
                    className={`header__main-nav-item${
                      item.key === "copytrade"
                        ? " header__main-nav-item--copytrade"
                        : ""
                    }`}
                  >
                    <NavLink
                      to={item.to}
                      aria-disabled={item.isDisabled ? "true" : "false"}
                      tabIndex={item.isDisabled ? -1 : 0}
                      onClick={(e) => {
                        if (!item.isDisabled) return;
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                      className="header__main-nav-link"
                    >
                      <span
                        className={`header__main-nav-text${
                          item.isDisabled
                            ? " header__main-nav-text--disabled"
                            : ""
                        }`}
                      >
                        {__(item.textKey)}
                      </span>
                    </NavLink>
                    {item.isDisabled && (
                      <span className="header__main-nav-icon">
                        <BlockIcon />
                      </span>
                    )}
                  </li>
                ))}
              </ul>
            </>
          </div>
        ) : (
          <div className="header__left">
            <Link className="header__logo" to="/">
              <LogoIcon isLanding={isLandingView} />
            </Link>
          </div>
        )}
        {!isAuth ? (
          <Unauthorized sidebarToggle={sidebarToggle} />
        ) : isDemoUser && (isMainPage || isAuthRoute) ? (
          <Authorized sidebarToggle={sidebarToggle} />
        ) : (
          <Authorized sidebarToggle={sidebarToggle} />
        )}
      </div>
    </header>
  );
};
